//loading
$(window).on('load', function () {
	if ($('body').css('opacity') == 0) {
	  setTimeout(function () {
		$('body').css('opacity', '1');
	  }, 1000);
	}
  });
  
  
  //megamenu
  $('.mega-menu').each(function () {
	$(this).hover (function() {
	  $(this).attr('open',true);
	  $(this).attr('aria-expanded',true);
	  $(this).children('.mega-menu__content').fadeIn();
	}, function() {
	  $(this).children('.mega-menu__content').mouseover (function(){
	  });
	  $(this).attr('open',false);
	  $(this).attr('aria-expanded',false);
	  $(this).children('.mega-menu__content').fadeOut();
	});
  });
  
  //lottie
  $(function () {
  
	var cats = [];
	var catanim = [];
  
	$('.catsvg').not('.professional-team .catsvg').each(function () {
	  var num = $('.catsvg').not('.professional-team .catsvg').index($(this));
	  var $this = $(this);
	  var id = $(this).attr('id');
	  var json = $(this).attr('data-svg');
	  cats[num] = {
		container: document.getElementById(id),
		renderer: 'svg',
		loop: true,
		autoplay: false,
		path: json,
	  };
	  catanim[num] = lottie.loadAnimation(cats[num]);
	});
  
  
  //smooth scroll
	// $('a[href*=\\#]:not([href=\\#]) ').click(function () {
	  
	//   if (
	// 	location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
	// 	location.hostname == this.hostname
	//   ) {
	// 	console.log(location.pathname);
	// 	var $target = $(this.hash);
	// 	$target = ($target.length && $target) || $('[name=' + this.hash.slice(1) + ']');
	// 	if ($target.length) {
	// 	  if ($(this).parents('.menuBox').length) {
	// 		console.log(location.pathname);
	// 		setTimeout(function () {
	// 		  var targetOffset = $target.offset().top - $('.section-header').outerHeight();
	// 		  $('html,body').animate({ scrollTop: targetOffset }, 1000);
	// 		}, 100);
	// 	  } else {
	// 		var targetOffset = $target.offset().top - $('.section-header').outerHeight();
	// 		$('html,body').animate({ scrollTop: targetOffset }, 1000);
	// 	  }
	// 	  return false;
	// 	}
	//   }
	// });
  
	var state = false;
	var scrollpos;
  
	$('.menu').on('click', function () {
	  if (state == false) {
		scrollpos = $(window).scrollTop();
		$('body').addClass('fixed').css({ top: -scrollpos });
		$('.menuBox').addClass('show');
		state = true;
	  } else {
		$('body').removeClass('fixed').css({ top: 0 });
		window.scrollTo(0, scrollpos);
		$('.menuBox').removeClass('show');
		state = false;
	  }
	  return false;
	});
	var topTxt = 0;
	if ($('.utility-bar').length) {
	  topTxt = $('.utility-bar').outerHeight();
	}
  
	//professional-team
	$(window)
	  .scroll(function () {
		var scroll = $(window).scrollTop();
  
		$('.catsvg').not('.professional-team .catsvg').each(function (index) {
		  var height = 0;
		  var cattop = $(this).offset().top - window.innerHeight - height;
		  if (scroll > cattop) {
			$(this).addClass('playing');
			catanim[index].play();
		  }
		});
  
		var breakPoint = 1008;
  
		$('.product-carousel .slideList').each(function () {
		  if($(this).hasClass('pc-noslide') && window.innerWidth >= breakPoint) {
  
		  } else {
			var num = $(this).children('.slick-slide').length - 2;
			if (num < 2) {
			  num = 2;
			}
			$(this).not('.slick-initialized').slick({
			  slidesToShow: num,
			  variableWidth: true,
			  autoplay: true,
			  arrows: true,
			  pauseOnHover: false,
			  pauseOnFocus: false,
			  infinite: true,
			  prevArrow: $(this).next().children('.prev'),
			  nextArrow: $(this).next().children('.next')
			});
		  }
				 
		  var moveTop = $('.content.laid').offset().top - window.innerHeight;
		  if (scroll > moveTop) {
			var sl = scroll - moveTop;
			var height = window.innerHeight - $('.section-header').outerHeight();
			var op = sl / height;
			op = op * 100;
			if (op > 100) {
			  op = 100;
			}
			$('.content.laid .img').css('left', op + '%');
			$('.content.laid .img').css('transform', 'translateX(-' + (100 - op) + '%)');
		  } else {
			$('.content.laid .img').css('left', '0');
			$('.content.laid .img').css('transform', 'translateX(-100%)');
		  }
  
	  });
		
		$('.para').each(function () {
		  var site = $(this).offset().top - window.innerHeight;
		  var para = scroll - site;
		  if ($(this).parents('.sec03').length) {
			if (window.matchMedia && window.matchMedia('(max-device-width: 1008px)').matches) {
			  $(this)
				.find('img')
				.css('transform', 'scale(1.05) translateY(-' + para / 6 + 'px)');
			} else {
			  $(this)
				.find('img')
				.css('transform', 'scale(1.05) translateY(-' + para / 2.5 + 'px)');
			}
		  } else {
			$(this)
			  .find('img')
			  .css('transform', 'scale(1) translateY(' + para / 10 + 'px)');
		  }
		});
		/*
		  if(scroll > topTxt || $('body').hasClass('fixed')){
			  $('.section-header').addClass('fixed');
		  }else{
			  $('.section-header').removeClass('fixed');
		  }*/
	  })
	  .trigger('scroll');
	//$('#container').css('padding-top', $('.section-header').outerHeight());
  });
  
  //
  $(window).on('load', function () {
	var localLink = window.location + '';
	if (localLink.indexOf('#') != -1 && localLink.slice(-1) != '#') {
	  localLink = localLink.slice(localLink.indexOf('#') + 1);
	  $('html,body').animate({ scrollTop: $('#' + localLink).offset().top }, 500);
	}
  });
  
  //fadein
  $(function () {
	$(window).scroll(function () {
	  const windowHeight = $(window).height();
	  const scroll = $(window).scrollTop();
  
	  $('.element').each(function () {
		const targetPosition = $(this).offset().top;
		if (scroll > targetPosition - windowHeight + 100) {
		  $(this).addClass('is-fadein');
		}
	  });
	  $('.element2').each(function () {
		const targetPosition = $(this).offset().top;
		if (scroll > targetPosition - windowHeight + 150) {
		  $(this).addClass('is-fadein');
		}
	  });
	});
  });
  
  //cookie
//   (function () {
// 	const expire = 365; // 有効期限（日）
// 	let cc = document.querySelector('.cookie-consent');
// 	let ca = document.querySelector('.cookie-agree');
// 	let cclose = document.querySelector('.js_cookie_close');
// 	const flag = localStorage.getItem('popupFlag');
// 	if (flag != null) {
// 	  const data = JSON.parse(flag);
// 	  if (data['value'] == 'true') {
// 		popup();
// 	  } else {
// 		const current = new Date();
// 		if (current.getTime() > data['expire']) {
// 		  setWithExpiry('popupFlag', 'true', expire);
// 		  popup();
// 		}
// 	  }
// 	} else {
// 	  setWithExpiry('popupFlag', 'true', expire);
// 	  popup();
// 	}
// 	ca.addEventListener('click', () => {
// 	  cc.classList.add('cc-hide1');
// 	  setWithExpiry('popupFlag', 'false', expire);
// 	});
// 	cclose.addEventListener('click', () => {
// 	  cc.classList.add('cc-hide1');
// 	});
  
// 	function setWithExpiry(key, value, expire) {
// 	  const current = new Date();
// 	  expire = current.getTime() + expire * 24 * 3600 * 1000;
// 	  const item = {
// 		value: value,
// 		expire: expire,
// 	  };
// 	  localStorage.setItem(key, JSON.stringify(item));
// 	}
  
// 	function popup() {
// 	  cc.classList.add('is-show');
// 	}
//   })();
  /*
  $(function(){
	  $('.js_slideArea ul').infiniteslide({
		  'clone': 10,
		  pauseonhover: false
	  });
  
  });*/
  $(function () {
	$('.js_copy_click').on('click', function () {
	  let text = $('.js_copy_click').prev('a').text();//'meow@uniam.jp';
	  if(navigator.clipboard == undefined) {
		  window.clipboardData.setData('Text', text);
	  } else {
		  navigator.clipboard.writeText(text);
	  }
	  $('.js_copy_click').text('copied');
	});
  });
  
  $('.viewmore button').each(function () {
	$(this).on('click', function () {
	  if ($(this).next($('.viewmore .more')).css('display') === 'none') {
		$(this).next($('.viewmore .more')).css('display', 'block');
		$(this).css('display', 'none');
	  } else {
		$(this).next($('.viewmore .more')).css('display', 'none');
	  }
	});
  });
  